import DEFINES from '@/defines';
// COMPANY
import CompanyHome from '@/pages/company/Home';
import CompanyFestivals from '@/pages/company/Festivals';
import CompanyAbout from '@/pages/company/About';
import CompanyPrivacy from '@/pages/company/Privacy';
import CompanyTerms from '@/pages/company/Terms';
import CompanyPage from '@/pages/company/Page';
import CompanyPostPaymentRedirection from '@/pages/company/PostPaymentRedirection';
// SCREENER
import ScreenerRoot from '@/pages/screener/Root';
import ScreenerToday from '@/pages/screener/Today';
import ScreenerUpcoming from '@/pages/screener/Upcoming';
import ScreenerOngoing from '@/pages/screener/Ongoing';
import ScreenerArchive from '@/pages/screener/Archive';
import ScreenerOverview from '@/pages/screener/ScreenerOverview';
import ScreenerWatch from '@/pages/screener/Watch';
import AccessLink from '@/pages/screener/AccessLink';
import PageNotFound from '@/pages/PageNotFound';

//VOD MOVIES
import VodMovies from '@/pages/vod/VodMovies';
import GeoGraphicalCatalogue from '@/pages/vod/GeoGraphicalCatalogue'
// CONSUMER
import ConsumerRoot from '@/pages/consumer/Root';
import ConsumerDashboard from '@/pages/consumer/Dashboard';
// AUTH
import Login from '@/pages/auth/Login';
import OAuthLogin from '@/pages/auth/OAuthLogin';
import LoginLink from "@/pages/auth/LoginLink"

// MONETIZATION
import MonetizationRoot from '@/pages/monetization/Root';
import GroupTicketList from '@/pages/monetization/GroupTicketList';
import GroupTicketOverview from '@/pages/monetization/GroupTicketOverview';

// SUBSCRIPTION
import SubscriptionRoot from '@/pages/subscription/Root';
import SubscriptionPlans from '@/pages/subscription/Plans';
import SubscriptionSuccess from '@/pages/subscription/Success';

import FilmMakerProfile from '@/pages/company/FilmMakerProfile'

// Program
import Program from '@/pages/company/Program';

export default [
  //Guest pages
  {
    path: '/',
    name: 'company.dashboard',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: CompanyHome,
  },
  {
    path: '/festivals',
    name: 'company.festivals',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: CompanyFestivals,
  },
  // Program
{
  path: '/program',
  name: 'program',
  meta: {
    layout: DEFINES.LAYOUT_GUEST,
    public: true,
  },
  component: Program,
},
  /* Subscriptions */
  {
    path: '/subscription',
    name: 'subscription',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: SubscriptionRoot,
    redirect: {name: 'subscription.plans'},
    children: [
      {
        path: 'plans',
        name: 'subscription.plans',
        component: SubscriptionPlans,
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        }
      },
      {
        path: 'success',
        name: 'subscription.success',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        },
        component: SubscriptionSuccess,
      },
    ]
  },
  {
    path: '/payment/returnUrl:response?',
    name: 'company.paymentreturnurl',
    meta: {
      layout: DEFINES.LAYOUT_AUTH,
      public: true,
    },
    component: CompanyPostPaymentRedirection,
  },
  {
    path: '/login',
    name: 'company.login',
    meta: {
      layout: DEFINES.LAYOUT_AUTH,
      public: true,
    },
    component: Login,
  },
  {
    path: '/oauth/login',
    name: 'company.oauth.login',
    meta: {
      layout: DEFINES.LAYOUT_AUTH,
      public: false,
    },
    component: OAuthLogin,
  },
  {
    path: '/verify/:session_key/:otp',
    name: 'company.verify',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: LoginLink,
  },
  {
    path: '/about',
    name: 'company.about',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: CompanyAbout,
  },
  {
    path: '/privacy',
    name: 'company.privacy',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: CompanyPrivacy,
  },
  {
    path: '/terms',
    name: 'company.terms',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: CompanyTerms,
  },
  {
    path: '/:slug',
    name: 'company.page',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: CompanyPage,
  },

  /* Screeners */
  {
    path: '/screeners',
    name: 'screeners',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
    },
    component: ScreenerRoot,
    children: [
      {
        path: 'today',
        name: 'screeners.today',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        },
        component: ScreenerToday,
      },
      {
        path: 'upcoming',
        name: 'screeners.upcoming',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        },
        component: ScreenerUpcoming,
      },
      {
        path: 'ongoing',
        name: 'screeners.ongoing',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        },
        component: ScreenerOngoing,
      },
      {
        path: 'archive',
        name: 'screeners.archive',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        },
        component: ScreenerArchive,
      },
      //redirect old urls to new urls
      {
        path: 'today/:screener_id/login',
        name: 'screeners.today.login',
        redirect: {name: 'screeners.watch'},
      },
      {
        path: 'upcoming/:screener_id/register',
        name: 'screeners.upcoming.register',
        redirect: {name: 'screeners.register'},
      },
      {
        path: 'upcoming/:screener_id/register/:customer_id',
        name: 'screeners.upcoming.register.confirm',
        redirect: {name: 'screeners.verify'},
      },
      {
        path: ':screener_id',
        name: 'screeners.overview',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        },
        component: ScreenerOverview,
      },
      {
        path: ':screener_id/watch',
        name: 'screeners.watch',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: false,
        },
        component: ScreenerWatch,
      },
      {
        path: ':screener_id/link/:link_id',
        name: 'screeners.access-link',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        },
        component: AccessLink,
      },
    ],
  },
  /* User */
  {
    path: '/user',
    name: 'user',
    redirect: 'user/dashboard',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
    },
    component: ConsumerRoot,
    children: [
      {
        path: 'dashboard',
        name: 'user.dashboard',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: false,
        },
        component: ConsumerDashboard,
      },
    ],
  },
  // Monetization
  {
    path: '/pricing',
    redirect: 'pricing/plans',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
    },
    component: MonetizationRoot,
    children: [
      {
        path: 'plans',
        name: 'pricing.index',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        },
        component: GroupTicketList,
      },
      {
        path: ':pricing_id',
        name: 'pricing.overview',
        meta: {
          layout: DEFINES.LAYOUT_COMPANY,
          public: true,
        },
        component: GroupTicketOverview,
      },
    ],
  },
  /**
   * VOD Routes
   */
  {
    path: '/vod/movies',
    name: 'vod.movies',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: VodMovies,
  },
  {
    path: '/vod/geo-graphical-catalogue',
    name: 'vod.geo-graphical-catalogue',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: GeoGraphicalCatalogue,
  },
  {
    path: '/film-maker/:filmMakerId',
    name: 'film.maker.profile',
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
      public: true,
    },
    component: FilmMakerProfile,
  },
  {
    path: '/*',
    name: 'abort',
    component: PageNotFound,
    meta: {
      layout: DEFINES.LAYOUT_COMPANY,
    },
  },

];
